import { Route } from 'react-router-dom';
import LegalSettingsPage from './pages/LegalSettingsPage';

export const LegalRoutes = [
  <Route key="legal-settings" path="/dashboard/legal" element={<LegalSettingsPage />} />
];